import { Duration } from 'dayjs/plugin/duration.js';
import { ICloneable } from '../../../contracts/cloneable.js';
import { IDataComparable } from '../../../contracts/data-comparable.js';
import { IDiagnosticableObject } from '../../../contracts/diagnosticable-object.js';
import { SerializedData } from '../../dto/dto.js';
import { TimeOfDay } from '../time-of-day.js';

export abstract class CalendarDaySlot implements ICloneable, IDataComparable, IDiagnosticableObject {
    abstract clone(): this
    abstract isSame(other: this): boolean

    abstract get entryId(): string
    abstract get duration(): Duration
    abstract get timeOfDay(): TimeOfDay

    abstract toDiagnosticsObject(): SerializedData
}
